import { app } from "./app";
import { asiasweep } from "./asiasweep";
import { illusbills } from "./illusbills";
import { illusion } from "./illusion";
import { intel } from "./intel";
import { lexicon } from "./lexicon";
import { mail } from "./mail";
import { naked } from "./naked";
import { nyorb } from "./nyorb";
import { svp } from "./svp";
import { catalog } from "./catalog";
import { domain } from "./domain";
import { setup } from "./setup";
import { ui } from "./ui";

export type Locale = "de" | "en";

/** Merged dictionaries. Each module exports `{ en, de }` with flat keys. */
export const MESSAGES: Record<Locale, Record<string, string>> = {
  en: { ...domain.en, ...catalog.en, ...app.en, ...intel.en, ...setup.en, ...mail.en, ...illusbills.en, ...illusion.en, ...asiasweep.en,...naked.en,...nyorb.en, ...svp.en,...lexicon.en, ...ui.en },
  de: { ...domain.de, ...catalog.de, ...app.de, ...intel.de, ...setup.de, ...mail.de, ...illusbills.de, ...illusion.de, ...asiasweep.de,...naked.de,...nyorb.de, ...svp.de,...lexicon.de, ...ui.de },
};
